/**
 * 표시용 값 정리 유틸.
 * 컬럼명을 하드코딩하지 않고 값의 형태로만 판단 — 데이터 브라우저의 범용성 유지.
 */

/**
 * 타임스탬프 형태의 값에서 밀리초(소수 초)와 타임존을 제거.
 * 예: '2026-08-12 17:36:03.535031+09' → '2026-08-12 17:36:03'
 *     '2026-08-04T02:26:44.173Z'      → '2026-08-04T02:26:44'
 * 날짜/시각 전체 일치가 아니면 원본 그대로 반환(부분 매칭으로 다른 텍스트 훼손 방지).
 */
const TIMESTAMP_RE =
  /^(\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}(?::?\d{2})?)?$/;

export function stripTimePrecision(value: string): string {
  const m = value.trim().match(TIMESTAMP_RE);
  return m ? m[1] : value;
}

/**
 * groupby 그룹 값(문자열/불리언/숫자/null 혼재)을 표시용 문자열로 정규화.
 * 서버가 flag 컬럼을 JSON boolean(true/false)으로 주므로, React가 boolean을
 * 빈 값으로 렌더하거나 문자열 정렬(localeCompare)이 깨지는 것을 방지한다.
 * - null/undefined → '(null)'
 * - boolean        → 'true' / 'false'
 * - 그 외          → String(v)
 */
export function formatGroupValue(v: unknown): string {
  if (v === null || v === undefined) return '(null)';
  if (typeof v === 'boolean') return v ? 'true' : 'false';
  return String(v);
}
